module.exports = __webpack_public_path__ + "static/media/hammock.4779cf61.jpg";